import { Grid, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiPrinter, mdiFileExcelOutline } from '@mdi/js';
import List from './response3plList';
import ExcelExport from './excelExport';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';

export function Response3PL(props: any) {
  const fetchTapinString = async (selectedTapins) => {
    try {
      const delayTime = 1000; 
      const response = await ordersRepository.getOrderTapin({ payload: { ids: selectedTapins } })
      const newWindow = window.open('about:blank', '_blank');
      newWindow?.document.open();
      newWindow?.document.write(response.data);
      setTimeout(() => newWindow?.print() , delayTime );
         } catch (err) {
      handleError(err)
    }
  };
  return (
    <Grid container spacing={3}>
      <Grid
        style={{ margin: 0 }}
        spacing={5}
        container
        alignItems={'center'}
        justify={'space-between'}
      >
        <Grid item>
          {props.data.length} {'سفارش'}
        </Grid>
        <Grid item>
          {props.data && (
            <ExcelExport
              data={props.data}
            />
          )
          }
          <IconButton
            onClick={() => {
              const win = window.open(
                `/3pl-print-labels?id=${props.data[0].orderId}`,
                '_blank'
              )!;
            }}
            style={{
              border: '2px solid ',
              marginLeft: '5px',
              borderRadius: '5px',
            }}
          >
            <Icon path={mdiPrinter} size={1} color={'primary'} />
          </IconButton>
          <IconButton
            onClick={() => {
              fetchTapinString(props.data[0].orderId);
              //  const win = window.open(
              //
              //  )!;
            }}
            style={{
              border: '2px solid ',
              marginLeft: '5px',
              borderRadius: '5px',
            }}
          >
            <Icon
              path={mdiPrinter}
              size={1}
              color={'secondary'}
            />
            <Typography variant="subtitle1">تاپین</Typography>
          </IconButton>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <List data={props.data} />
      </Grid>
    </Grid>
  );
}
